import styles from "../../css/home.module.css";
import ParticlesComponent from "../../components/particles/particles";
import AOS from "aos";
import LineTimeComponent from "../home/lineTime";
import FilterableCards from "../../components/cards/cardProjects";

import React, { useEffect } from "react";
import icons from "../../css/icons.module.css";
export default function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    // <-- Añadir return aquí explícitamente
    <div className={styles.containerMain}>
      <link
        href="https://unpkg.com/aos@2.3.1/dist/aos.css"
        rel="stylesheet"
      ></link>

      <div className={styles.particlesContainer}>
        <ParticlesComponent />

        <div className={styles.DinamicBgContainer}>
          <div>
            <div className={styles.containerTitle}>
              <p className={`${styles.titlePage} ${styles.typingEffect}`}>
                James Kalith
              </p>
            </div>

            <p className={styles.description}>
              Soy una persona activa con grandes aspiraciones y ansias de
              aprender y mejorar cada día.
            </p>
          </div>

          <div className={styles.containerTitle}>
            <p className={`${styles.titleSkill} `}>Me caracteriza</p>
          </div>

          <div className={styles.containerLabel}>
            <span className={styles.labelSkill}>Pasión por la tecnología</span>

            <span className={styles.labelSkill}> Creatividad</span>
            <span className={styles.labelSkill}> Trabajo en equipo</span>
            <span className={styles.labelSkill}> Pensamiento crítico</span>
            <span className={styles.labelSkill}> Perseverancia </span>
          </div>
        </div>
        <div className={styles.photoContainer}>
          <div>
            <img
              className={styles.profileImg}
              src="img/profilePhoto.jpg"
              alt="Descripción"
            />
            <div className={styles.flexIcons}>
              <a
                href="
            https://www.instagram.com/jkalith.dev?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==
            "
              >
                <div className={icons.instagram}></div>
              </a>
              <a
                href="


https://www.linkedin.com/in/jkalith/

"
              >
                <div className={icons.linkedin}></div>
              </a>
            
      <a   href="mailto:jamesarias2383@gmail.com?subject=Estoy interesado en tu curriculum ">
     

 
              <div className={icons.email}></div>
              </a>
              <a   href="https://api.whatsapp.com/send/?phone=50661506639&text&type=phone_number&app_absent=0">
              <div className={icons.whatsapp}></div></a>
            </div>
          </div>
        </div>
      </div>

      <div data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className={styles.sectionProject}>

        <div className={styles.line}></div>

        <div className={styles.projectContainer}>
          <p className={styles.titleSectionP}>Mis proyectos </p>
          <div className={styles.flexBetween}></div>

          <div className={styles.containerCard}>
            <FilterableCards />
          </div>
        </div>

        <div>
          <LineTimeComponent />
        </div>
      </div>
    </div>
  );
}
